


































































































































































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@/utils/common";
import { Table } from "@/utils/decorator";
import ConfirmPaymentItem from "./components/confirm-payment.vue";
import RegisterInvoice from "./components/register-invoice.vue";

import dayjs from "dayjs";
const service = namespace("service");
const base = namespace("base");
const staff = namespace("staff");
const purchase = namespace("purchase");
const supplier = namespace("supplier");

const typeMap: any = {
  maintenance: 1,
  wash: 2,
  retail: 3
};
@Component({
  components: { ConfirmPaymentItem, RegisterInvoice }
})
@Table("loadListData")
export default class ServiceList extends Vue {
  dayjs = dayjs;
  @base.Action getDictionaryList;
  @staff.Action getStaffList;
  @purchase.Action purchaseComplete;
  @purchase.Action getPurchaseList;
  @supplier.Action getSupplierList;
  @service.Action createInvoice;
  @purchase.Action createPurchasePayment;
  @purchase.Mutation setPaymentBtnLoading;
  @purchase.Mutation setMakeInvoiceBtnLoading;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  orderList: any[] = [];
  searchForm = {
    purchaseNo: "",
    supplierCode: "",
    purchaseStatus: "",
    settlementStatus: "",
    purchaseDateBegin: "",
    purchaseDateEnd: ""
  };
  showComfirmPayment: boolean = false;
  showRegisterInvoice: boolean = false;
  orderStatusList: any[] = [];
  staffList: any[] = [];
  defaultExpend: boolean = false;
  handlePaymentConfirmClick(data) {
    let params = {
      orderList:
        data.settleType === 1
          ? [{ orderNo: this.willUpdateRow.purchaseNo }]
          : data.selectedRows.map(item => {
              item.orderNo = item.purchaseNo;
              return item;
            }),
      paidList: [
        {
          paidAmount: data.settleType === 1 ? this.willUpdateRow.purchaseAmount : 0,
          paidMethod: data.paidMethod
        }
      ],
      remark: ""
    };
    this.setPaymentBtnLoading(true);
    this.createPurchasePayment(params)
      .then(data => {
        this.$message.success(this.$t("base.payment-success") as string);
        this.showComfirmPayment = false;
        this.loadListData();
      })
      .finally(() => {
        this.setPaymentBtnLoading(false);
      });
  }
  handleInvoiceConfirmClick(data) {
    this.setMakeInvoiceBtnLoading(true);
    this.createInvoice(data)
      .then(data => {
        this.$message.success(this.$t("purchase.invoice-register-success") as string);
        this.showRegisterInvoice = false;
        this.loadListData();
      })
      .finally(() => {
        this.setMakeInvoiceBtnLoading(false);
      });
  }
  handleComfirmCommand(command) {
    switch (command) {
      case "payment":
        this.showComfirmPayment = true;
        break;
      case "invoice":
        this.showRegisterInvoice = true;
        break;
      default:
        this.handleComplete();
      // 完成入库
    }
  }
  created() {
    this.init();
    this.loadListData();
  }
  settlementList: any = [];
  init() {
    // 获取供应商
    this.searchSupplier();
    // 结算方式字典List
    this.getDictionaryList("purchase_settlement_status").then(data => {
      this.settlementList = data;
    });
    // 订单状态字典List
    this.getDictionaryList("purchase_status").then(data => {
      this.orderStatusList = data;
    });
    // 员工和顾问 List
    this.getStaffList({
      pageSize: 999,
      pageNum: 1
    }).then(data => {
      const staffList =
        data.data.list &&
        data.data.list.map(item => ({
          label: item.staffName,
          value: item.userCode
        }));
      this.staffList = staffList;
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getPurchaseList({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = data.data.list;
      return data;
    });
  }
  handleSwitchStatus(tab) {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  handleComplete() {
    this.purchaseComplete({
      purchaseNo: this.willUpdateRow.purchaseNo
    }).then(data => {
      this.$message.success(this.$t("warehouse.inbound-success") as string);
      this.loadListData();
    });
  }
  get searchList() {
    return [
      {
        label: "purchase.purchase-no",
        type: "input",
        value: "",
        prop: "purchaseNo"
      },
      {
        label: "supplier.name",
        type: "select-search",
        value: "",
        prop: "supplierCode",
        placeholder: this.$t("base.input-keyword-search"),
        selectList: this.supplierList,
        searchFun: this.searchSupplier
      },
      {
        label: "base.order-status",
        type: "select",
        selectList: this.orderStatusList,
        value: "",
        prop: "purchaseStatus"
      },
      {
        label: "base.settlement-status",
        type: "select",
        selectList: this.settlementList,
        value: "",
        prop: "settlementStatus"
      },
      {
        label: "purchase.purchase-date",
        type: "daterange",
        value: "",
        prop: "purchaseDate"
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "purchaseDate") {
          this.searchForm["purchaseDateBegin"] = item.value ? item.value[0] : "";
          this.searchForm["purchaseDateEnd"] = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  supplierList: any = [];
  searchSupplier(val = "") {
    this.getSupplierList({
      pageNum: 1,
      pageSize: 10,
      supplierName: val
    }).then(data => {
      this.supplierList = data.data.list
        ? data.data.list.map(item => {
            item.label = item.supplierName;
            item.value = item.supplierCode;
            return item;
          })
        : [];
    });
  }
  willUpdateRow: any = {};
  handleSetCurrentRow(visible, row) {
    if (visible) {
      this.willUpdateRow = row;
    }
  }
  handleEdit(row) {
    this.$router.push(`/purchase/purchase-edit/${row.purchaseNo}`);
  }
  handleLinkOrderView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/purchase/purchase-view/${row.purchaseNo}`
    });
    window.open(href, "_blank");
  }
}
